class RotorisGallery extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-rd-gallery-track]');
    this.items = Array.from(this.querySelectorAll('[data-rd-gallery-item]'));
    this.bars = Array.from(this.querySelectorAll('[data-rd-gallery-bar]'));
    this.progress = this.querySelector('[data-rd-gallery-progress]');
    this.tabs = Array.from(this.querySelectorAll('[data-rd-gallery-tab]'));

    if (!this.scroller || this.items.length === 0) return;

    this.onScroll = this.onScroll.bind(this);
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
    this.bars.forEach((bar, index) => {
      bar.addEventListener('click', () => {
        this.items[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const type = tab.getAttribute('data-rd-gallery-tab');
        const target = type === 'gallery'
          ? this.items[0]
          : this.items.find((item) => item.getAttribute('data-rd-media-type') === type);

        target?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
    this.onScroll();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const left = this.scroller.scrollLeft;
    let active = 0;
    let best = Infinity;

    this.items.forEach((item, index) => {
      const distance = Math.abs(item.offsetLeft - left);
      if (distance < best) {
        best = distance;
        active = index;
      }
    });

    this.bars.forEach((bar, index) => {
      bar.classList.toggle('is-active', index === active);
      bar.setAttribute('aria-current', index === active ? 'true' : 'false');
    });

    if (this.progress) {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const ratio = max > 0 ? this.scroller.scrollLeft / max : 0;
      const minimum = this.items.length > 1 ? 100 / this.items.length : 100;
      const width = Math.max(minimum, Math.min(100, ratio * 100));
      this.progress.style.width = `${width}%`;
    }

    this.tabs.forEach((tab) => {
      const type = tab.getAttribute('data-rd-gallery-tab');
      const isActive = type === 'gallery'
        ? active === 0 || this.items[active]?.getAttribute('data-rd-media-type') === 'image'
        : this.items[active]?.getAttribute('data-rd-media-type') === type;
      tab.classList.toggle('is-active', isActive);
    });
  }
}

if (!customElements.get('rotoris-gallery')) {
  customElements.define('rotoris-gallery', RotorisGallery);
}
